import { useEffect, useState } from "react";
import { API } from "../../constant";
import { FetchAPIContext } from "../FetchAPIContext";
import Loading from "../../Components/Hooks/Loading";

const Api = (props)=>{

    const [apiData, setApiData] = useState();
    const [loading, setLoading] = useState();

    const callApi = (url) =>{
        setLoading(true);
        fetch(`${API}/${url}`).then((response) => {
            return response.json();
        }).then((responseData) => {
            // const dataobject = {
            //     id:responseData.id,
            // }
            setApiData(responseData);   
            setLoading(true);
        });
        setLoading(false);
    }
    // if(loading)
    //     window. "loading";
    return(
        <FetchAPIContext.Provider value={{apiData, callApi, loading}}>
            {props.children}
        </FetchAPIContext.Provider>
    );
}

export default Api;